// Shared formatters & helpers used across pages
export const STAGES = [
  { key: "qualification", label: "Qualification", color: "bg-slate-100 text-slate-700 border-slate-200" },
  { key: "demonstration", label: "Demonstration", color: "bg-teal-50 text-teal-700 border-teal-200" },
  { key: "decision_makers", label: "Identifying Decision Makers", color: "bg-blue-50 text-blue-700 border-blue-200" },
  { key: "budgetary_quotes", label: "Budgetary Quotes", color: "bg-violet-50 text-violet-700 border-violet-200" },
  { key: "under_budget_approval", label: "Under Budget Approval", color: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200" },
  { key: "budget_approval", label: "Budget Approved", color: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "purchase_enquiry", label: "Purchase Enquiry", color: "bg-orange-50 text-orange-800 border-orange-200" },
  { key: "technical_evaluation", label: "Technical Evaluation", color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { key: "negotiation", label: "Negotiation", color: "bg-rose-50 text-rose-800 border-rose-200" },
  { key: "won", label: "Closed Won", color: "bg-primary-50 text-primary-700 border-primary-200" },
  { key: "lost", label: "Closed Lost", color: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  { key: "dropped", label: "Dropped", color: "bg-stone-100 text-stone-500 border-stone-200" },
];

// Training pipeline keeps things simple — only three open stages plus the
// usual terminal triplet, matching the lightweight workflow on the spec.
export const TRAINING_STAGES = [
  { key: "enquiry", label: "Enquiry", color: "bg-slate-100 text-slate-700 border-slate-200" },
  { key: "registration", label: "Registration", color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { key: "schedule", label: "Schedule", color: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "won", label: "Closed Won", color: "bg-primary-50 text-primary-700 border-primary-200" },
  { key: "lost", label: "Closed Lost", color: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  { key: "dropped", label: "Dropped", color: "bg-stone-100 text-stone-500 border-stone-200" },
];

export const PIPELINE_TYPE_LABEL = {
  product:  "Product Pipeline",
  service:  "Technical Services Pipeline",
  training: "Training Pipeline",
};

export function stagesForPipeline(pt) {
  return pt === "training" ? TRAINING_STAGES : STAGES;
}

// Hex colours mapped to the Tailwind palette — lets raw-SVG charts (Timeline
// Trend) paint each stage with the same hue as the kanban column.
export const STAGE_HEX = {
  qualification: "#64748b",
  demonstration: "#14b8a6",
  decision_makers: "#3b82f6",
  technical_evaluation: "#6366f1",
  budgetary_quotes: "#8b5cf6",
  under_budget_approval: "#d946ef",
  budget_approval: "#f59e0b",
  purchase_enquiry: "#f97316",
  negotiation: "#f43f5e",
  won: "#026928",
  lost: "#52525b",
  dropped: "#78716c",
};

export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));

export function fmtINR(v) {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return v;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}k`;
  return `₹${n.toLocaleString("en-IN")}`;
}

export function fmtDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtDateTime(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function followupBucket(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dd = new Date(d);
  dd.setHours(0, 0, 0, 0);
  if (dd < today) return "overdue";
  if (dd.getTime() === today.getTime()) return "today";
  return "upcoming";
}

export const BUCKET_STYLE = {
  overdue: {
    label: "Overdue",
    chip: "bg-red-50 text-red-700 border-red-200",
    dot: "bg-red-500",
  },
  today: {
    label: "Due today",
    chip: "bg-amber-50 text-amber-800 border-amber-200",
    dot: "bg-amber-500",
  },
  upcoming: {
    label: "Upcoming",
    chip: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
  },
};

export function todayISO() {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  return d.toISOString();
}
